import HttpService from './baseHttp'
// 基础数据

//分页查询
export const HttpReimbursementList = (data = {}) => HttpService.get("/api/v2/reimbursement/Reimbursement/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//分页查询
export const HttpReimbursements = (data = {}) => HttpService.get("/api/v2/reimbursement/Reimbursement/findByFilters", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

//管理端分页查询
export const HttpReimbursementManageList = (data = {}) => HttpService.get("/api/v2/reimbursement/Reimbursement/findByManage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });


//操作及改状态
export const HttplogOrderAction = (data = {}) => HttpService.post("/api/v2/reimbursement/Reimbursement/logOrderAction",data, {  baseURL: process.env.VUE_APP_APIURL_FBB });

//导入单据明细
export const HttpImportDetail = (data = {}) => HttpService.post("/api/v2/reimbursement/ReimbursementDetail/importReimbursementDetail",data, { baseURL: process.env.VUE_APP_APIURL_FBB });


//查询明细
export const HttpReimbursementDetail = (data = {}) => HttpService.post("/api/v2/reimbursement/ReimbursementDetail/findByHeadId",data, {baseURL: process.env.VUE_APP_APIURL_FBB });

//保存单据头
export const HttpReimbursementSave = (data = {}) => HttpService.post("/api/v2/reimbursement/Reimbursement/saveData",data, { baseURL:  process.env.VUE_APP_APIURL_FBB });

//查询索赔单
export const HttpReimbursementGetById = (data = {}) => HttpService.get("/api/v2/reimbursement/Reimbursement/getById", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

//添加单据明细
export const HttpReimbursementDetatilSave = (data = {}) => HttpService.post("/api/v2/reimbursement/ReimbursementDetail/saveDetailData",data, { baseURL:  process.env.VUE_APP_APIURL_FBB  });

//删除单据明细
export const HttpReimbursementRemove = (data = {}) => HttpService.post("/api/v2/reimbursement/ReimbursementDetail/delete",data, { baseURL: process.env.VUE_APP_APIURL_FBB });

//清空单据明细
export const HttpClearReimbursementDetail = (data = {}) => HttpService.post("/api/v2/reimbursement/ReimbursementDetail/deleteAll",data, { baseURL: process.env.VUE_APP_APIURL_FBB });

//批量添加备注
export const HttpBatchAddRemark = (data = {}) => HttpService.post("/api/v2/reimbursement/Reimbursement/batchAddRemark",data, { baseURL: process.env.VUE_APP_APIURL_FBB });

//批量审核
export const HttpBatchAudit = (data = {}) => HttpService.post("/api/v2/reimbursement/Reimbursement/batchAudit",data, { baseURL: process.env.VUE_APP_APIURL_FBB});
//批量完成
export const HttpBatchComplete = (data = {}) => HttpService.post("/api/v2/reimbursement/Reimbursement/batchComplete",data, { baseURL: process.env.VUE_APP_APIURL_FBB});
//订单单条查询
export const HttpOrderId = (data = {}) => HttpService.get("/api/v2/B2cOrder/findOne", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });
export const HttpReturnByOrderId= (data = {}) => HttpService.get("/api/v2/orderSerivce/findReturnByOrderId", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });
//查询当前组织SKU
export const HttpFindBySku = (data = {}) => HttpService.get("/api/v1/Product/findByErpSku", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });


//根据售后单号查询退货单信息
export const HttpReturnByServiceNo = (data = {}) => HttpService.get("/api/v2/orderSerivce/findReturnByServiceNo", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });


//订单单条查询-根据trackingNo获取销售订单信息
export const HttpFindOneByTrackingNo = (data = {}) => HttpService.get("/api/v2/B2cOrder/findOneByTrackingNo", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

//根据入库计划单根据多个单号查询
export const HttpInboundPlanOrderNos = (data = {}) => HttpService.get("/api/v2/Inbound/getByInboundPlanOrderNos", { params: data, baseURL:  process.env.VUE_APP_APIURL_FBB });

//判断是否当前组织下 入库单号
export const HttpInboundPlanCheck = (data = {}) => HttpService.get("/api/v2/Inbound/selectByOrgIdAndNo", { params: data, baseURL:  process.env.VUE_APP_APIURL_FBB });
// 编辑附件删除
export const HttpDelRelAttach = (data = {}) => HttpService.get('/api/v2/reimbursement/Reimbursement/delRelAttach', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});
//尾程索赔文件删除
export const HttpDelPropAttach = (data = {}) => HttpService.get('/api/v2/reimbursement/Reimbursement/delPropAttach', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});

// 附件添加
export const HttpAddRelAttach = (data = {}) => HttpService.get('/api/v2/reimbursement/Reimbursement/addRelAttach', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 尾程索赔文件添加
export const HttpAddPropAttach = (data = {}) => HttpService.get('/api/v2/reimbursement/Reimbursement/addPropAttach', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 附件删除
export const HttpDelFile = (data = {}) => HttpService.get('/api/v1/BizAttach/del', { params: data, baseURL: process.env.VUE_APP_APIURL_UC });

//调账
export const HttpCheckBill = (data = {}) => HttpService.post("/api/v2/reimbursement/Reimbursement/checkBill",data, {  baseURL: process.env.VUE_APP_APIURL_FBB});

//批量提交
export const HttpbatchSubmitBill = (data = {}) => HttpService.post("/api/v2/reimbursement/Reimbursement/batchSubmit",data, {  baseURL: process.env.VUE_APP_APIURL_FBB});

export const HttpCountReimbursementList = (data = {}) => HttpService.get('/api/v2/reimbursement/Reimbursement/groupByStatus', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});
export const HttpCountReimbursementManageList  = (data = {}) => HttpService.get('/api/v2/reimbursement/Reimbursement/groupByStatusManage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

//根据退货tracking查询
export const HttpGetReturnByTrackingNo = (data = {}) => HttpService.get("/api/v2/orderSerivce/findReturnByTrackingNo", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

export const HttpGetFbbReturnByTrackingNo = (data = {}) => HttpService.get("/api/v2/saleReturnPlanOrder/findByReturnTrackingNo", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpGetTrackingNoByLabel = (data = {}) => HttpService.get("/api/v2/orderShipment/getByTrackingNo/"+data.trackingNo, {  baseURL: process.env.VUE_APP_APIURL_SHIP });

export const HttpHosWarehouse = (data = {}) => HttpService.post("/api/v2/customerRate/getHosWarehouseCapacity", data, { baseURL: process.env.VUE_APP_APIURL_FBB});
// 当前组织的上属组织
export const HttpGetBeforeOrgList = (data = {}) => HttpService.get('/api/v1/Context/organizationHosts', { params: {module:'Organization', oid:global.SYSID,...data}, baseURL: process.env.VUE_APP_APIURL_UC })

// 下载索赔单附件
export const HttpExportClaimStatement = (data = {}, config) => HttpService.get("/api/v2/reimbursement/Reimbursement/exportAttach", { params: data,baseURL: process.env.VUE_APP_APIURL_FBB, ...config });

// 索赔单Tracking查询
export const HttpFindByTrackingNoNew = (data = {}) => HttpService.get("/api/v2/reimbursement/ReimbursementDetail/checkTrackingExist", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

//编辑平台结果
export const HttpEditPlatformResult = (data = {}) => HttpService.post("/api/v2/reimbursement/Reimbursement/editPlatformResult",data, { baseURL: process.env.VUE_APP_APIURL_FBB});
